<div class="dialog-content-min">
  <form [formGroup]="finYearForm">
    <div class="formgrid grid m-2">
      <div class="field col-12">
        <label for="finyr" class="required-label">Financial Year<span class="maxchars">(Max 50 chars)</span><span>*</span></label>
        <input type="text" class="form-control" placeholder="Enter Financial Year" id="finyr"
          formControlName="finyr" required name="finyr" pInputText> 
        <span class="errormessage"
          *ngIf="finYearForm.get('finyr').invalid && (finYearForm.get('finyr').dirty || finYearForm.get('finyr').touched)">
          {{getErrorMessage(finYearForm ,validation_message,'finyr')}}
        </span> 
      </div>
    </div>


    <div class="formgrid grid m-2" *ngIf="isEdit">
      <div class="field col-12">
        <label for="activeflag"> Active Flag </label>
        <p-dropdown [options]="activeFlag" id="activeflag" [filter]="true" appendTo="body" name="activeflag"
          optionLabel="labelname" optionValue="value" placeholder="Select Flag" [resetFilterOnHide]="true" 
          formControlName="activeflag"></p-dropdown>
        <span class="errormessage" *ngIf="finYearForm.get('activeflag').invalid && finYearForm.get('activeflag').touched ">
          {{getErrorMessage(finYearForm ,validation_message,'activeflag')}}
        </span>
      </div>
    </div>
  </form>
</div>

 
   <div class="custom-dialog-footer">
        <p-button class="m-1" label="Close" styleClass="customeclose" (click)="closemodal(finYearForm,this.ref,'Are you sure you want to close?')"></p-button>

        <p-button class="m-1" *ngIf="hasLimitedAccess =='N' || saveTitle == 'Add'"  label="{{saveTitle}}" styleClass="customesave"
            (click)="addYear()"></p-button>
    </div>
 